import { COLORS, newLayout } from '../theme';

export default {
  styleOverrides: {
    root: {
      color: COLORS.black30,
      fontWeight: 500,
      fontSize: newLayout.fontSize.body3,
      transition: 'color .15s ease',
      '&.Mui-disabled': {
        color: newLayout.text.disabled,
      },
      '&.Mui-error': {
        color: newLayout.text.red,
      },
    },
  },
};
